<template>
    <div class="welcome">
      <v-layout column>
            <v-flex xs12>
                <v-img
                    dark
                    height="250"
                    src="img/cover_photo.png"
                    >
                    <div align="center" class="font-weight-black mt-16">
                        <h1>About</h1>
                    </div>
                    <!-- <div align="center" class="mt-2">
                        Embracing equity in women-led startups
                    </div> -->
                    
                </v-img>
            </v-flex>
            <v-flex xs12 class="white">
                <v-container>
                    <div align="center" class="mt-15">
                        <p class="grey--text text--darken-1">
                            The Women in Tech Accelerator, Kenya, is designed to empower women-led, tech-enabled startups to grow, scale, and create positive economic and social impact.
                        </p>
                        <p class="grey--text text--darken-1">
                            The programme is an initiative of the Standard Chartered Foundation delivered in partnership with Village Capital and @iBizAfrica Incubation Centre at Strathmore University.
                        
                            Through an immersive accelerator journey, founders receive structured business growth training, mentorship from industry experts, and hands-on advisory support to strengthen their business models, sharpen strategy, and prepare for investment and scale.
                      
                            Participants also gain access to a powerful network of ecosystem partners, investors, and fellow founders, helping them unlock new opportunities, partnerships, and markets.
                       
                            By supporting women entrepreneurs building innovative, tech-enabled startups, the programme contributes to job creation, inclusive economic growth, and the development of sustainable solutions addressing some of the continent’s most pressing challenges.
                        </p>
                    </div>
                </v-container>
            </v-flex>
            <v-flex xs12 class="white">
                <v-container>
                    <v-layout column>
                        <v-flex xs12 class="mt-7">
                            <v-card elevation="0" style="background-image: linear-gradient(to bottom right, rgb(20, 72, 53), rgb(20, 72, 53, 0.6));">
                                <v-layout row wrap>
                                    <v-flex xs12 md8 class="pa-15">
                                        <div align="center">
                                            <v-icon 
                                            color="white"
                                            size="100px"
                                            >
                                                mdi-earth
                                            </v-icon>
                                        </div>
                                        <div align="center" class="font-weight-black white--text mt-3">
                                            Acceleration Component
                                        </div>
                                        <div align="center" class="white--text mt-5">
                                            The methodology for the accelerator program will address the following core components of business development and investor readiness.
                                        </div>
                                        <!-- <div align="center">
                                            <v-icon
                                            color="white"
                                            x-large
                                            >
                                                mdi-arrow-right-thick
                                            </v-icon>
                                        </div> -->
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="mx-3">
                                            <v-img src="img/incubation.jpg" style="border-radius: 4px 4px 4px 4px;"> </v-img>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 class="mt-8">
                            <v-card elevation="0" style="background-image: linear-gradient(to top right, rgb(0, 138, 0), rgb(0, 138, 0, 0.4));">
                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <v-img src="img/learning.jpg" style="border-radius: 4px 4px 4px 4px;" class="mx-3"> </v-img>
                                    </v-flex>
                                    <v-flex xs12 md8 class="pa-13">
                                        <div align="center">
                                            <v-icon 
                                            color="white"
                                            size="100px"
                                            >
                                                mdi-school
                                            </v-icon>
                                        </div>
                                        <div align="center" class="font-weight-black white--text mt-3">
                                            Immersive Learning
                                        </div>
                                        <div align="center" class="white--text mt-5">
                                            Entrepreneurs undergo an in depth evaluation of the current state of their company operation. This informs the methodology of curriculum delivery meeting unique needs of each venture.
                                        </div>
                                        <!-- <div align="center">
                                            <v-icon
                                            color="white"
                                            x-large
                                            >
                                                mdi-arrow-left-thick
                                            </v-icon>
                                        </div> -->
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 class="mt-8">
                            <v-card style="background-image: linear-gradient(to bottom right, rgb(20, 72, 53), rgb(20, 72, 53, 0.6));" elevation="0">
                                <v-layout row wrap>
                                    <v-flex xs12 md8 class="pa-14">
                                        <div align="center">
                                            <v-icon 
                                            color="white"
                                            size="100px"
                                            >
                                                mdi-account-child-circle
                                            </v-icon>
                                        </div>
                                        <div align="center" class="font-weight-black white--text mt-3">
                                            Mentorship & Coaching
                                        </div>
                                        <div align="center" class="white--text mt-5">
                                            Inhouse mentors coaches walk the acceleration journey with entrepreneurs by facilitating customized mentorship and coaching sessions addressing each company's needs.
                                        </div>
                                        <!-- <div align="center">
                                            <v-icon
                                            color="white"
                                            x-large
                                            >
                                                mdi-arrow-right-thick
                                            </v-icon>
                                        </div> -->
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="mx-3">
                                            <v-img src="img/mentor.jpg" style="border-radius: 4px 4px 4px 4px;"> </v-img>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 class="mt-8">
                            <v-card elevation="0" style="background-image: linear-gradient(to top right, rgb(0, 138, 0), rgb(0, 138, 0, 0.4));">
                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <v-img src="img/finance.jpg" style="border-radius: 4px 4px 4px 4px;" class="mx-3"> </v-img>
                                    </v-flex>
                                    <v-flex xs12 md8 class="pa-11">
                                        <div align="center">
                                            <v-icon 
                                            color="white"
                                            size="100px"
                                            >
                                                mdi-cash-100
                                            </v-icon>
                                        </div>
                                        <div align="center" class="font-weight-black white--text mt-3">
                                            Access to Seed Financing 
                                        </div>
                                        <div align="center" class="white--text mt-5">
                                            The top 7 Startups will have the opportunity to secure $10,000 in seed funding to scale their ventures
                                        </div>
                                        <!-- <div align="center">
                                            <v-icon
                                            color="white"
                                            x-large
                                            >
                                                mdi-arrow-left-thick
                                            </v-icon>
                                        </div> -->
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 class="mt-8 mb-16">
                            <v-card style="background-image: linear-gradient(to bottom right, rgb(20, 72, 53), rgb(20, 72, 53, 0.6));" elevation="0">
                                <v-layout row wrap>
                                    <v-flex xs12 md8 class="pa-14">
                                        <div align="center">
                                            <v-icon 
                                            color="white"
                                            size="100px"
                                            >
                                                mdi-google-circles-communities
                                            </v-icon>
                                        </div>
                                        <div align="center" class="font-weight-black white--text mt-3">
                                            Networking
                                        </div>
                                        <div align="center" class="white--text mt-5">
                                            Companies are able to access a rich network of enablers and partners within and outside the ecosystem; enabling them to create sustainable partnerships for business growth
                                        </div>
                                        <!-- <div align="center">
                                            <v-icon
                                            color="white"
                                            x-large
                                            >
                                                mdi-arrow-right-thick
                                            </v-icon>
                                        </div> -->
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <div class="mx-3">
                                            <v-img src="img/networking.jpg" style="border-radius: 4px 4px 4px 4px;"> </v-img>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
                
            </v-flex>
            <v-flex xs12 class="background">
                <v-container class="my-16">
                    <v-layout row wrap class="mx-1 my-2">
                    <v-flex xs12 md6 color="#525355" class="accent pa-16">
                            <div class="title white--text mt-7 font-weight-black">
                                Eligibility Criteria
                            </div>
                            <p class="white--text mt-3">
                                We are seeking to recruit the best entrepreneurial minds, women-led startups as key drivers of innovation in business.
                            </p>
                            <p class="white--text mt-3">
                                The Eligibility criteria is as follows:
                            </p>
                            <p class="white--text mt-3 mb-7">
                                <ul>
                                    <li>
                                        Women-led founders between 18-35 years old.
                                    </li>
                                    <li>
                                        Business must be headquartered and operating in Kenya.
                                    </li>
                                    <li>
                                        Legally registered, for-profit startup (1–10 employees).
                                    </li>
                                    <li>
                                        Must have a Tax Compliance Certificate
                                    </li>
                                    <li>
                                        Revenue-generating, with an annual revenue between KES 500,000 – 1,000,000.
                                    </li>
                                    <li>
                                        At least one woman founder and one full-time founder must be based in Nairobi, Kenya.
                                    </li>
                                    <li>
                                        Business must be tech-based or tech-enabled.
                                    </li>
                                    <li>
                                        Business models must have a clear focus on inclusivity and address specific social, economic, or environmental issues aligned with the Sustainable Development Goals (SDGs) in any sector.
                                    </li>
                                    <li>
                                        Persons with Disabilities (PWDs) are encouraged to apply.
                                    </li>
                                    
                                </ul>
                            </p>
                        
                    </v-flex>
                    <v-flex xs12 md6 class="white pa-16">
                            <div class="title black--text mt-7 font-weight-black">
                                Program Benefits
                            </div>
                            <p class="black--text mt-3">
                                <ul>
                                    <li>
                                        12 weeks of an immersive learning experience
                                    </li>
                                    <li>
                                        Access to a leading network of coaching experts
                                    </li>
                                    <li>
                                        Access to networking opportunities
                                    </li>
                                    <li>
                                        Personalized mentorship sessions to address your unique business needs
                                    </li>
                                    <li>
                                        Opportunity to join a supportive Women in Tech Alumni Network
                                    </li>
                                    <li>
                                        $10,000 equity-free grant seed funding for the top 7 finalists
                                    </li>
                                    <li>
                                        6 months post-incubation support from Village Capital and @iBizAfrica to assist with the go-to market and scale for the top seven finalists
                                    </li>
                                </ul>
                            </p>
                            <div class="title black--text mt-7 font-weight-black">
                                Terms & Conditions
                            </div>
                            <p>                                
                                <ul>
                                    <li>
                                        Successful completion of the <b>Women In Tech Accelerator Program (WIT)</b> is compulsory for all participants.
                                    </li>
                                    <li>
                                        Attendance and active participation in all scheduled masterclasses, mentoring sessions, and program activities are required to maintain eligibility for funding and program benefits.
                                    </li>
                                    <li>
                                        Participants must commit to all <b>in-person or virtual meetings</b> as deemed necessary by the program organizers.
                                    </li>
                                    <li>
                                        Compliance with all applicable <b>business regulations and legal requirements</b> is expected throughout the program duration.
                                    </li>
                                </ul>
                            </p>
                        
                    </v-flex>
                </v-layout>
                </v-container>

            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import apiCall from "@/utils/api";
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";

export default {
  components: {
    
  },
  data() {
    return {
      path: process.env.VUE_APP_API_URL,
      color: "",
      message: "",
      snackbar: false,
      drawer: false,

      absolute: true,
      overlay: true,
      opacity: 0.3,
    };
  },
  mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.changeHeaderColor("white");
    this.changeTitleColor("red--text");
    this.changeButtonColor("red--text hidden-sm-and-down text-none caption");
  },
  methods: {
    ...mapActions([
        "changeHeaderColor",
        "changeTitleColor",
        "changeButtonColor"
    ]),
      changeColor() {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          this.changeHeaderColor("white");
          this.changeTitleColor("black--text");
          this.changeButtonColor("black--text hidden-sm-and-down text-none caption");
        } else {
          this.changeHeaderColor("white");
          this.changeTitleColor("white--text");
          this.changeButtonColor("white--text hidden-sm-and-down text-none caption");
        }
      },
  },
  computed: {
    ...mapGetters(["darkState"]),
  },
};
</script>
